// Tiempo que una habitación permanece apartada antes de liberarse
export const APARTADA_DURATION_MS = 5 * 60 * 1000
